export const randomDate = (from: string, to: string = new Date().toISOString().split('T')[0]): string => {
  const timeFrom = new Date(from).getTime();
  const timeTo = new Date(to).getTime();

  const diffTime = timeTo - timeFrom;
  const randomTime = Math.floor(Math.random() * diffTime);

  return new Date(timeFrom + randomTime).toISOString().split('T')[0];
};
